import React, { useEffect, useState } from 'react';
import axiosInstance from '../../lib/axios';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Chip
} from '@mui/material';
import {
  Hotel as BedIcon,
  EventAvailable as CheckInIcon,
  EventBusy as CheckOutIcon,
  AccessTime as TimeIcon,
  CreditCard as CreditCardIcon,
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const DetailCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[2],
  '&:hover': {
    boxShadow: theme.shadows[6]
  }
}));

const DetailsTab = ({ bookingData }) => {
  const [planDrp, setPlanDrp] = useState([])
  console.log('bookingData detailes', bookingData)
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const fetchPlanDrpData = async () => {
    if (!bookingData?.PropId) return;

    // setPlanLoading(true);
    try {
      const response = await axiosInstance.post(
        `MstRoomPlan/RetriveMstRoomPlan`,
        {
          "RoomPlanID": bookingData.RoomPlanId,
          "Flag": "R"
        }
      );
      if (response.data.Status === 0) {
        setPlanDrp(response.data.Data);
      } else {
        console.error('Error fetching plan data');
      }
    } catch (error) {
      console.error('Error fetching plan data', error);
    } finally {
      //   setPlanLoading(false);
    }
  };
  useEffect(() => {
    fetchPlanDrpData()
  }, [])

  const getDaysRemaining = (checkin, checkout) => {
    if (!checkin || !checkout) return 'N/A';
    const checkinDate = new Date(checkin);
    const checkoutDate = new Date(checkout);
    const diffTime = checkoutDate - checkinDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
  };


  return (
    <Box sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <DetailCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BedIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Room Information
                </Typography>
              </Box>

              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Room/Bed No "
                    secondary={bookingData?.RoombedName || 'N/A'}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Room Type"
                    secondary={bookingData?.RoomTypeName || 'N/A'}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Floor"
                    secondary="3rd Floor"
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
              </List>
            </CardContent>
          </DetailCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <DetailCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TimeIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Booking Timeline
                </Typography>
              </Box>

              <List dense>
                <ListItem>
                  <ListItemIcon>
                    <CheckInIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Check-in"
                    secondary={formatDate(bookingData?.CheckinDt)}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" variant="inset" />

                <ListItem>
                  <ListItemIcon>
                    <CheckOutIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Check-out"
                    secondary={formatDate(bookingData?.CheckoutDt)}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" variant="inset" />

                <ListItem>
                  <ListItemIcon>
                    <TimeIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Days Remaining"
                    secondary={getDaysRemaining(bookingData?.CheckinDt, bookingData?.CheckoutDt)}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
              </List>
            </CardContent>
          </DetailCard>
        </Grid>

        {/* <Grid item xs={12} md={4}>
          <DetailCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CreditCardIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Payment Information
                </Typography>
              </Box>

              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Total Amount"
                    secondary={`${bookingData?.TotalRent || '0'}`}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Payment Method"
                    secondary="Credit Card"
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Payment Status"
                    secondary={
                      <Chip
                        label="Completed"
                        color="success"
                        size="small"
                        icon={<CheckCircleIcon fontSize="small" />}
                      />
                    }
                  />
                </ListItem>
              </List>
            </CardContent>
          </DetailCard>
        </Grid> */}
        <Grid item xs={12} md={4}>
          <DetailCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CreditCardIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Payment Plan
                </Typography>
              </Box>

              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Plan Name"
                    secondary={planDrp[0]?.PlanName || 'N/A'}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Min Adv Month"
                    secondary={planDrp[0]?.MinAdjMonths
                      ? `${planDrp[0]?.MinAdjMonths}`
                      : 'N/A'
                    }
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>

                <ListItem>
                  <ListItemText
                    primary="Total Installments"
                    secondary={planDrp[0]?.TotalInstall
                      ? `${planDrp[0]?.TotalInstall}`
                      : 'N/A'
                    }
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                  <ListItemText
                    primary="Deposit"
                    secondary={planDrp[0]?.DepositAmt || 'N/A'}
                    secondaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                  />
                </ListItem>
              </List>
            </CardContent>
          </DetailCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsTab;